import api from "./api"
const apmRoleNameGet = localStorage.getItem("role");
export const fetchDraftApplicatrions = async (districtId, zoneId) => {


  let url = `/api/personal-info/selected-statuses`
  if (districtId != null && (apmRoleNameGet === "PM" && apmRoleNameGet === 'APM OPERATIONS')) {
    url += `?districtId=${districtId}`;
  }
  if (zoneId != null && apmRoleNameGet === "APM Zone") {
    url += `?zoneId=${zoneId}`
  }
  const response = await api.get(url)
  return response;

}

export const deleteDraft = async (employeeUniqueId) => {
  try {
    const response = await api.delete(`/api/personal-info/${employeeUniqueId}`);
    return response.data;
  } catch (error) {
    console.error("Error in deleteDraft service:", error);
    throw error;
  }
};

// export const resendPersonalInfoLink = async (employeeUniqueId) => {
//   try {
//     const response = await api.post(`/api/personal-info/${employeeUniqueId}/send-email`);
//     return response.data;
//   } catch (error) {
//     console.error("Error in resendPersonalInfoLink service:", error);
//     throw error;
//   }
// };


export const resendPersonalInfoLink = async (employeeUniqueId, payload) => {
  try {
    const response = await api.post(
      `/api/personal-info/${employeeUniqueId}/send-email`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // If your backend returns { ... } in response.data
    return response.data;
  } catch (error) {
    console.error("Error in resendPersonalInfoLink service:", error);
    // rethrow so callers can catch
    throw error;
  }
};